import {
  cloneDeep,
} from 'lodash';

import {
  importJsonData,
  initGetData,
} from '@/payloadTemplates';

const {
  templates,
  prefill = {},
} = importJsonData(
  require.context('./', false, /\.json$/),
  // require.context('./prefill/', false, /\.json$/),
);

const getData = initGetData(templates, prefill);

export const BICYCLE = getData(['bicycle']);
export const COVER = getData('cover');
export const YOUR_DETAILS = getData('yourDetails');

export const QUOTE = {
  bicycles: [BICYCLE],
  cover: cloneDeep(COVER),
  yourDetails: cloneDeep(YOUR_DETAILS),
};

export const getQuotePayload = config => {
  const payload = cloneDeep(QUOTE);
  payload.yourDetails.userKeepSignIn = !config.hiddenQuestions['user-keep-me-sign-in'];

  return payload;
};
